import styled from 'styled-components';

const StaticPagesWrapper = styled.div`
  min-height: calc(100vh - 250px);
  padding-bottom: 50px;
  box-sizing: border-box;
  .static-page-title {
    margin: 20px 0;
  }
`;

export default StaticPagesWrapper;
